export default __webpack_public_path__ + "static/media/stoyan_s.c16a293c.jpg";